let historyRef = null;

export const setNavigator = (history) => {
  historyRef = history;
};

export const pushHistory = (path, state = {}) => {
  if (historyRef) {
    historyRef.push(path, state);
  } else {
    console.warn("History is not initialized yet");
  }
};

export const replaceHistory = (path, state = {}) => {
  if (historyRef) {
    historyRef.replace(path, state);
  } else {
    console.warn("History is not initialized yet");
  }
};